import { render, staticRenderFns } from "./AIColourMatchV2Modal.vue?vue&type=template&id=5dc680ca&"
import script from "./AIColourMatchV2Modal.vue?vue&type=script&lang=js&"
export * from "./AIColourMatchV2Modal.vue?vue&type=script&lang=js&"
import style0 from "./AIColourMatchV2Modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports